const Configure = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 17H13" stroke="currentColor" strokeLinecap="round" />
      <path d="M10 7H20" stroke="currentColor" strokeLinecap="round" />
      <circle cx="17" cy="17" r="3.5" stroke="currentColor" />
      <circle cx="6" cy="7" r="3.5" stroke="currentColor" />
    </svg>
  )
}

export default Configure
